package org.hs_soft.runmynesto.data.api_datasource.template

import com.varabyte.kobweb.browser.http.AbortController
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient

import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryData
import org.hs_soft.runmynesto.domain.repository.network_datasource.template.TemplateCategoryRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.config.Errors




class TemplateCategoryRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
//    private val apolloClient: ApolloClient,
) : TemplateCategoryRepository {

    private var abortController:AbortController?=null

    override suspend fun fetchTemplateCategoryList(): TemplateCategoryData {

        abortController=requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
                query listCategories {
                  cashAssist {
                    listCategories {
                      items {
                        ${ApiUtils.Field.id}
                        ${ApiUtils.Field.position}
                        ${ApiUtils.Field.name}
                        ${ApiUtils.Field.isActive}
                      }
                    }
                  }
                }
            """.trimIndent())
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController!!,
        )

        return if (result != null) {
            Json.decodeFromString<TemplateCategoryData>(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }


    }

    override fun cancel() {
        abortController?.abort()
        abortController=null
    }
}